var Numeric = new Class({
	Implements: [Options, Events],
	options: {
		cls: "w_fields",
		separator: ",",
		add_separators: true
	},

	initialize: function(element, options){
		if(!element) return;

		this.setOptions(options);
		this._element = element;

		this.build();
	},

	build: function(){
		var self = this;
		var fcls = '.' + this.options.cls;

		this._fields = this._element.getElements(fcls + '_numeric');
		this.locked = false;

		var add_separators = this.options.add_separators;

		this._fields.each(function(_el){
			var cur = _el.getAttribute('data-currency-sign');
			var _currency;

			if(cur && cur != ''){
				_currency = new Element('span', {
					'html': cur,
					'style': 'display: inline-block; padding: 9px 0;'
				}).inject(_el, 'before').hide();
			}

			_el.addEvent('keydown',	function(key){
				var key_code = key.code;

				if(self.check_key(_el, key)){
					self.previous_value = _el.value;

					var pos = self.get_caret_pos(_el);

					if(add_separators){
						if(key_code == '8' && _el.value.charAt(pos-1) == ','){
							self.set_caret_pos(_el, pos-1);
						}else if(key_code == '46' && _el.value.charAt(pos) == ','){
							self.set_caret_pos(_el, pos+1);
						}
					}
				}else{
					return false;
				}
			});

			var ev = (Core.is_ie8() ? 'change' : 'input');

			_el.addEvent(ev, function(){
				if(add_separators){
					self.add_commas(_el);
				}

				if(_currency){
					if(_el.value != ''){
						_currency.show();
					}else{
						_currency.hide();
					}
				}
			});

			if(add_separators){
				self.add_commas(_el);
			}

			if(_currency && _el.value != ''){
				_currency.show();
			}
		});
	},

	check_key: function(e, key){
		var key_code = key.code;

		return((key_code >= '96' && key_code <= '105') ||
					 (key_code >= '48' && key_code <= '57') ||
						key_code == '8' ||
						key_code == '9' ||
						key_code == '35' ||
						key_code == '36' ||
						key_code == '37' ||
						key_code == '39' ||
						key_code == '46'
					)&&(!key.shift);
	},

	add_commas: function(e){
		var pos = this.get_caret_pos(e),
				n_str = e.value,
				amount_of_commas_before = 0,
				amount_of_commas_after = 0;

		if(n_str.charAt(0) != '0'){
			if(n_str.match(/,/g)){
				amount_of_commas_before = n_str.match(/,/g).length;
			}

			if(n_str.length > 3){
				n_str += '';
				n_str = n_str.replace(/,/g, '');

				var rgx = /(\d+)(\d{3})/;

				while (rgx.test(n_str)){
					n_str = n_str.replace(rgx, '$1' + this.options.separator + '$2');
				}

				e.set('value', n_str);
			}

			if(e.get('value').match(/,/g)){
				amount_of_commas_after = e.get('value').match(/,/g).length;
			}

			pos += (amount_of_commas_after - amount_of_commas_before);

			this.pos = pos;
			this.set_caret_pos(e, pos);
		}else{
			e.set('value', this.previous_value);
			this.set_caret_pos(e, 0);
		}
	},

	get_caret_pos: function(e){
		if(!Core.is_visible(e)) return;

		var caret_pos = 0;	// IE Support

		if(document.selection){
			e.focus();
			var sel = document.selection.createRange ();
			sel.moveStart ('character', -e.value.length);
			caret_pos = sel.text.length;
		}

		// Firefox support
		else if(e.selectionStart || e.selectionStart == '0'){
			caret_pos = e.selectionStart;
		}

		return caret_pos;
	},

	set_caret_pos: function(e, pos){
		if(e.setSelectionRange){
			//e.focus(); affects to page scroll to the fields when page just opened
			e.setSelectionRange(pos,pos);
		}else if(e.createTextRange){
			var range = e.createTextRange();
			range.collapse(true);
			range.moveEnd('character', pos);
			range.moveStart('character', pos);
			range.select();
		}
	}
});
